export enum ViewPanelSettingType {
  LAYOUT = 'layout',
  FILTER = 'filter',
  SORT = 'sort',
  FIELDS = 'fields',
  OVERVIEW = 'overview',
}

export type ViewSettingConfigurationType =
  | ViewPanelSettingType.LAYOUT
  | ViewPanelSettingType.FILTER
  | ViewPanelSettingType.SORT
  | ViewPanelSettingType.FIELDS;
